import { createSelector } from 'reselect'
import { eventCountTextFromResult } from '../utils/searchResults'

const results = state => state.searchResults.results
const favourites = state => state.favourites
const limit = state => state.searchResults.limit

const addAdditionalFieldsResults = (results, favourites) => {
  return results.map(result => {
    const eventCountText = eventCountTextFromResult(result)

    result.events = result.events.map(event => {
      return {
        ...event,
        dates: event.dates.map(date => {
          return {
            day: date.day,
            month: date.month,
            weekDay: date.weekDay
          }
        })
      }
    })

    return {
      ...result,
      eventCountText,
      favourited: favourites.indexOf(`${result.id}`) > -1,
    }
  })
}

export const searchResultsSelector = createSelector(
  results,
  favourites,
  limit,
  addAdditionalFieldsResults
)
